function initVideo() {
  const videoContainer = document.getElementById('video');
  const video = document.getElementById('intro-video');
  const preloader = document.getElementById('preloader');
  const skipBtn = document.getElementById('video-skip');
  let introFinished = false;
  let playbackStarted = false;

  function finishIntro() {
    if (introFinished || !videoContainer) return;
    introFinished = true;
    document.documentElement.classList.add('transition');
    setTimeout(function() {
      videoContainer.remove();
    }, 1000);
  }

  if (!video || !preloader) {
    document.documentElement.classList.add('transition');
    return;
  }

  const mobile = window.matchMedia('(max-width: 768px)').matches;
  const chosenSrc = mobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
  if (!chosenSrc) {
    document.documentElement.classList.add('transition');
    return;
  }
  video.src = chosenSrc;
  video.defaultMuted = true;
  video.muted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.load();

  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      video.pause();
      finishIntro();
    });
  }

  function attachGestureUnlock() {
    function unlockOnce() {
      startPlayback();
    }
    videoContainer.addEventListener('touchstart', unlockOnce, { once: true, passive: true });
    videoContainer.addEventListener('click', unlockOnce, { once: true });
  }

  function startPlayback() {
    if (introFinished || playbackStarted) return;
    playbackStarted = true;
    document.documentElement.classList.add('video-ready');
    video.muted = true;
    const p = video.play();
    if (p !== undefined && typeof p.catch === 'function') {
      p.catch(function () {
        playbackStarted = false;
        attachGestureUnlock();
      });
    }
  }

  video.addEventListener('error', function () {
    if (!introFinished) finishIntro();
  });

  if (video.readyState >= 3) {
    startPlayback();
  } else {
    video.addEventListener('canplay', startPlayback, { once: true });
    video.addEventListener(
      'loadeddata',
      function () {
        if (video.readyState >= 3) startPlayback();
      },
      { once: true }
    );
    setTimeout(function () {
      if (!introFinished && !playbackStarted && video.readyState >= 2) startPlayback();
    }, 2500);
  }

  video.addEventListener('ended', finishIntro);
}
